/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$modal-background-color: #ffffff !default;
$modal-wrapper-background-color: rgba(0, 0, 0, 0.4) !default;
$modal-full-width-background-color: rgb(57, 57, 58, 0.9) !default;
$modal-full-width-on-filter-blur-background-color: rgba(0, 0, 0, 0.4) !default;
$modal-border-bottom-color: #1ea2b1 !default;
$modal-default-radius: 0 !default;
$modal-default-shadow: none !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

$padding-modal-footer-desktop: 56px;
$margin-modal-desktop: 56px;
$margin-modal-footer-desktop: -$margin-modal-desktop;

$padding-modal-tablet-larger: 40px;
$margin-modal-tablet: 40px;
$margin-modal-footer-tablet: -$margin-modal-tablet;

$padding-modal-footer-mobile: 16px;
$margin-modal-mobile: 16px;
$margin-modal-footer-mobile: -$margin-modal-mobile;

$padding-modal-fullWidth-desktop-tablet: 28px;
$margin-modal-fullWidth-desktop-tablet: -$padding-modal-fullWidth-desktop-tablet;
$margin-modal-fullWidth-desktop-tablet-bottom: -($padding-modal-fullWidth-desktop-tablet + 8px);

$padding-modal-bottom-mobile: 32px;
$width-modal-desktop: 790px;
$width-modal-tablet: 522px;
$width-modal-mobile: 100%;
$width-modal-full-width-tablet: 95%;

:host {
  box-sizing: border-box;
  font-family: $font-family-base;

  * {
    box-sizing: border-box;
  }

  @include slotted-margins("*:not([slot])");
}

.#{$prefix}wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: $modal-wrapper-background-color;
  opacity: 0;
  visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transform: scale(1.1);
  transition: visibility 0s linear 0.25s, opacity 0.25s 0s, transform 0.25s;
  //z-index: 2000; // this is the highest number that be found in repo (1999)
  pointer-events: none;

  @include for-size(phone) {
    justify-content: flex-end;
  }

  &.#{$prefix}full-width {
    background-color: $modal-full-width-background-color;
    @supports (backdrop-filter: blur()) {
      backdrop-filter: blur(10px);
      background-color: $modal-full-width-on-filter-blur-background-color;
    }
    .#{$prefix}modal {
      padding: $padding-modal-fullWidth-desktop-tablet;
      @include for-size(tablet) {
        width: $width-modal-full-width-tablet !important;
        max-width: $width-modal-full-width-tablet !important;
      }
      @include for-size(phone) {
        padding: $padding-modal-footer-mobile;
        width: $width-modal-mobile !important;
        max-width: $width-modal-mobile !important;
      }

      .#{$prefix}content-wrapper {
        padding-bottom: 8px;
      }
    }
    .#{$prefix}closingX {
      margin-right: 5px;
      margin-top: -4px;
      @include for-size(phone) {
        margin-right: 9px;
        margin-top: 0px;
      }
    }
  }

  &.#{$prefix}has-footer-color:not(.#{$prefix}full-width) {
    .#{$prefix}modal {
      @include for-size(desktop-or-larger) {
        padding: $padding-modal-footer-desktop;
      }
    }
  }

  &.#{$prefix}has-footer-color {
    .#{$prefix}modal {
      border-bottom: unset;
    }

    eon-ui-background {
      margin: 0px $margin-modal-footer-desktop $margin-modal-footer-desktop;
      @include for-size(tablet) {
        margin: 0 $margin-modal-footer-tablet $margin-modal-footer-tablet;
      }
      @include for-size(phone) {
        margin: 0 $margin-modal-footer-mobile -32px;
      }
    }

    .#{$prefix}button-container {
      padding: 16px $padding-modal-footer-desktop;
      @include for-size(tablet) {
        padding: 16px $padding-modal-tablet-larger;
      }
      @include for-size(phone) {
        padding: 16px $padding-modal-footer-mobile;
        margin-bottom: 0;
        margin-top: 8px;
      }
    }
  }

  &.#{$prefix}full-width.#{$prefix}has-footer-color {
    .#{$prefix}modal {
      &.#{$prefix}has-one-button {
        .#{$prefix}content-wrapper {
          padding-bottom: 0;
        }
        .#{$prefix}button-container {
          @include for-size(phone) {
            padding: 16px $padding-modal-footer-mobile;
          }
        }
      }
    }
    eon-ui-background {
      margin: 0px $margin-modal-fullWidth-desktop-tablet $margin-modal-fullWidth-desktop-tablet-bottom;
      @include for-size(phone) {
        margin: 0 $margin-modal-footer-mobile $margin-modal-footer-mobile;
      }
    }

    .#{$prefix}button-container {
      padding: 16px $padding-modal-fullWidth-desktop-tablet;
      @include for-size(phone) {
        padding: 16px $padding-modal-footer-mobile;
      }
    }
  }
}

.#{$prefix}visible {
  opacity: 1;
  visibility: visible;
  transform: scale(1);
  transition: visibility 0s linear 0s, opacity 0.25s 0s, transform 0.25s;
  pointer-events: all;
}

.#{$prefix}modal {
  position: relative;
  margin: $margin-modal-desktop auto $margin-modal-desktop auto;
  padding: $padding-modal-tablet-larger;
  height: auto; /* height: auto; has to be set until max-height is reached; Then switched to height: 100vh via JS;*/
  width: $width-modal-desktop;
  background-color: $modal-background-color;
  overflow: hidden;
  border-bottom: 4px solid $modal-border-bottom-color;
  border-radius: $modal-default-radius;
  box-shadow: $modal-default-shadow;

  &.#{$prefix}height-100 {
    height: 100%;
  }

  @include for-size(tablet) {
    width: $width-modal-tablet;
    padding: $padding-modal-tablet-larger;
  }
  @include for-size(phone) {
    width: $width-modal-mobile;
    padding: $padding-modal-footer-mobile $padding-modal-footer-mobile $padding-modal-bottom-mobile
      $padding-modal-footer-mobile;
    margin-bottom: 0;
  }

  &.#{$prefix}has-no-button {
    .#{$prefix}scroll-container {
      padding-bottom: 8px;
      @include for-size(phone) {
        margin-bottom: 24px;
      }
    }
  }
}

.#{$prefix}closingX {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 4px;
  @include for-size(tablet-or-larger) {
    margin-top: -17px;
    margin-right: -9px;
  }
  @include for-size(phone) {
    margin-right: 9px;
    margin-top: 0px;
  }
  .#{$prefix}icon-closing-x {
    cursor: pointer;
  }
}

.#{$prefix}content-wrapper {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.#{$prefix}headline-wrapper {
  padding: 8px 8px 16px 8px;
  position: relative;
  height: auto;
  flex: 0 0 auto;
}

/* .#{$prefix}headline-wrapper ~ .#{$prefix}scroll-container {
  padding-top: 8px;
} */

.#{$prefix}scroll-container {
  padding-right: 8px;
  padding-left: 8px;
  padding-top: 8px;
  position: relative;
  height: auto;
  overflow-y: auto;
  flex: 1 0 0%;
}

.#{$prefix}button-container {
  position: relative;
  text-align: left;
  margin-top: 8px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex: 0 0 auto;
  padding: 16px 8px 24px 8px;

  &.#{$prefix}hidden {
    display: none;
    visibility: hidden;
  }

  &.#{$prefix}hide-closing-x {
    @include for-size(tablet-or-larger) {
      padding-bottom: 8px;
    }
    padding-bottom: 0;
  }

  @include for-size(phone) {
    flex-direction: row;
    padding-top: 16px;
    margin-bottom: -24px;
    margin-top: 0px;
  }
}

.#{$prefix}button-left,
.#{$prefix}button-right {
  @include for-size(phone) {
    width: 100%;
  }
}

.#{$prefix}button-left {
  margin-right: 16px;
  @include for-size(phone) {
    margin-right: 0;
  }
}

.#{$prefix}button-right {
  @include for-size(phone) {
    margin-top: 12px;
  }
}

::slotted([slot="button-right"]) {
  @include for-size(phone) {
    width: 100%;
  }
}
